<template>
  <CustomModal v-if="importOpened"
               :closable-on-click-outside="false"
               @close="$emit('close')">
    <template v-slot:body>
      <div class="import-portfolio-modal">
        <div class="text-xl font-bold text-text leading-tight mb-8">{{ $t('importLabel') }}</div>
        <StepDisplay class="mb-8" :current-step="current_step"/>
        <ImportPortfolioStep1 v-if="current_step === 1"
                              @upload="fetchReportDetails($event)"/>
        <ImportPortfolioStep2 v-else-if="current_step === 2"
                              :report-data="fetched_report"
                              :submitted="submitted"
                              @applyReport="applyReport($event)"
                              @cancel="current_step = 1"/>
        <ImportPortfolioStep3 v-else-if="current_step === 3"
                              @finish="$emit('close')"/>
      </div>
    </template>
  </CustomModal>
</template>

<script>
import CustomModal from "@/components/UI/modals/CustomModal";
import StepDisplay from "@/components/cabinet/Investments/modals/ImportPortfolioModal/StepDisplay";
import ImportPortfolioStep1 from "@/components/cabinet/Investments/modals/ImportPortfolioModal/ImportPortfolioStep1";
import ImportPortfolioStep2
  from "@/components/cabinet/Investments/modals/ImportPortfolioModal/ImportPortfolioStep2/ImportPortfolioStep2";
import ImportPortfolioStep3 from "@/components/cabinet/Investments/modals/ImportPortfolioModal/ImportPortfolioStep3";
import {mapActions} from "vuex";

export default {
  name: "ImportPortfolioModal",
  components: {
    CustomModal,
    StepDisplay,
    ImportPortfolioStep1,
    ImportPortfolioStep2,
    ImportPortfolioStep3
  },
  props: {
    importOpened: {
      required: true
    }
  },
  data() {
    return {
      current_step: 1,
      fetched_report: null,
      submitted: false
    }
  },
  methods: {
    ...mapActions('investments/portfolios', ['uploadPortfolio', 'importPortfolio']),
    fetchReportDetails(report) {
      this.fetched_report = report;
      this.current_step = 2;
    },
    applyReport(appliedDuplicateIds = []) {
      this.submitted = true;
      this.importPortfolio(appliedDuplicateIds).then(res => {
        if (res.body.success) {
          this.current_step = 3;
        } else {
          console.log(res);
          this.$toasted.error(this.$t('importError'))
        }
        this.submitted = false;
      }).catch(e => {
        this.submitted = false;
        console.log(e)
      })
    },
    resetModal() {
      this.current_step = 1;
      this.fetched_report = null;
      this.submitted = false;
    }
  },
  watch: {
    importOpened: {
      handler(newVal, oldVal) {
        if (newVal === false) {
          if (this.current_step === 2) {
            this.$store.dispatch('investments/portfolios/uploadPortfolio',
                {portfolio_id: this.$store.state.investments.portfolios.current_portfolio.data.id})
          }
          this.resetModal();
        }
      }
    }
  },
  i18n: {
    messages: {
      en: {
        importLabel: 'Broker report import',
        importError: 'Error occurred'
      },
      ru: {
        importLabel: 'Импорт отчета брокера',
        importError: 'Произошла ошибка'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.import-portfolio-modal {
  width: 1110px;
}
</style>